import "./navlink-tab.css";
import { NavLink } from "../../../app/router/routes/NavLink";
import { capitalizeAll } from "../../../core/utils/helpers";

const NavLinkTab = ({ tab_data, style = "style-1" }) => {
  return (
    <div className={`navlink-tab ${style}`}>
      {tab_data?.map((item, idx) => {
        const Icon = item?.icon;
        return (
          <NavLink
            activeClassName="active-option"
            inactiveClassName="inactive-option"
            className="nl-t-item"
            to={item?.nav_to}
            exact={item?.is_exact}
            key={idx}
          >
            {Icon && <Icon className="icon" />}
            <span>{capitalizeAll(item?.title)}</span>
          </NavLink>
        );
      })}
    </div>
  );
};

export default NavLinkTab;
